import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

type EntityResponseType = HttpResponse<any>;

@Injectable({ providedIn: 'root' })
export class GlobalParameterService {

  public resourceUrl = environment.serverURL + '/api/payment';

  constructor(protected http: HttpClient) {
  }

  create(parameter: any): Observable<EntityResponseType> {
    return this.http.post<any>(`${this.resourceUrl}/save-global-parameter`, parameter, { observe: 'response' });
  }

  find(): Observable<EntityResponseType> {
    return this.http.get<any>(`${this.resourceUrl}/info`, { observe: 'response' });
  }

}
